export enum FunctionButtonText {
    CustomFunction = 'Add Custom Function',
    SelectFunction = 'Select Function'
}
